import { Outlet } from "react-router-dom";
import { ComplianceBanner } from "../compliance/ComplianceBanner";
import { AdminHeader } from "./AdminHeader";
import { AdminHeaderSidebar } from "./AdminHeaderSidebar";
import { AdminSidebar } from "./AdminSidebar";
import { ErrorBoundary } from "@shared/components/ErrorBoundary";
import { MobileAdminLayout } from "../mobile/MobileAdminLayout";
import { useIsMobile } from "@shared/hooks/useIsMobile";
import { DataUseReacknowledgmentModal } from "../onboarding/DataUseReacknowledgmentModal";
import { useNavLayout } from "../../lib/useNavLayout";

export function AdminShell() {
  const isMobile = useIsMobile();
  const { layout } = useNavLayout();

  if (isMobile) return <MobileAdminLayout />;

  const content = (
    <div className="rounded-2xl bg-surface min-h-[calc(100vh-140px)] p-6">
      <ErrorBoundary>
        <Outlet />
      </ErrorBoundary>
    </div>
  );

  return (
    <div className="min-h-screen bg-bg">
      <ComplianceBanner />
      {layout === "sidebar" ? (
        <>
          <AdminHeaderSidebar />
          <div className="flex">
            <AdminSidebar />
            <main className="flex-1 min-w-0 px-6 py-6">{content}</main>
          </div>
        </>
      ) : (
        <>
          <AdminHeader />
          <main className="px-6 py-6">
            <div className="mx-auto max-w-7xl">{content}</div>
          </main>
        </>
      )}
      <DataUseReacknowledgmentModal />
    </div>
  );
}
